export class BadResponseError extends Error {}
